import { Button, Flex, message, Modal, Typography } from "antd"
import { FC, useEffect, useState } from "react"

const { Text } = Typography

interface IUserDataModal {
  open: boolean
  email: string
  password: string
}

const UserDataModal: FC<IUserDataModal> = ({ open, email, password }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  useEffect(() => {
    setIsOpen(open)
  }, [open])

  function copy() {
    navigator.clipboard.writeText(`email: ${email}\npassword: ${password}`)
    message.success("Copy to clipboard")
  }

  return (
    <Modal title="User login data" open={isOpen} onCancel={() => setIsOpen(false)} footer={false}>
      <Flex vertical gap="small">
        <Text>email: {email}</Text>
        <Text>password: {password}</Text>
        <Button onClick={copy}>Copy</Button>
      </Flex>
    </Modal>
  )
}

export default UserDataModal
